import { To } from 'history';
import history from 'history/browser';
import { useCallback, useEffect, useState } from 'react';

const _history = history || {};

const parseUrl = (url: string) => {
  const pathSearch = url.split('?');
  const hash = pathSearch?.[1]?.split('#')?.[1] || pathSearch[0].split('#')?.[1] || undefined;
  const search = pathSearch?.[1]?.split('#')?.[0] || undefined;
  const pathname = pathSearch[0].split('#')[0];

  return {
    hash: (hash && `#${hash}`) || undefined,
    search: (search && `?${search}`) || undefined,
    pathname,
  };
};

const urlOrObject = (to: string | To) => {
  if (to.constructor === String) {
    return parseUrl(to as string);
  }

  return to;
};

export default <S = undefined>() => {
  const [location, setLocation] = useState(_history.location);

  useEffect(() => {
    const unlisten = _history.listen((update) => {
      setLocation(update.location);
    });

    return unlisten;
  }, []);

  return {
    back: _history.back,
    listen: _history.listen,
    location: location,
    push: useCallback((to: string | To, state?: any) => _history.push(urlOrObject(to), state), []),
    state: location?.state as any as S,
    replace: useCallback(
      (to: string | To, state?: any) => _history.replace(urlOrObject(to), state),
      [],
    ),
  };
};
